import React, { useState, useEffect } from 'react';
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/common.css";
import "../styles/form.css";

const ContactThanks = () => {

  return (
    <>
      <Navbar />
      <main className='contact'>
        <section className='contact form'>
          <h1>お問い合わせありがとうございます。</h1>
          <p className='form-lead'>この度は弊社ホームページをご利用いただきまして、誠にありがとうございます。<br />
            お問い合わせいただきました内容を確認後、担当者より改めてご連絡いたします。</p>
          <div className='button-content button-arrow button-black'>
            <a href="/">TOPページに戻る</a>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default ContactThanks;
